import { Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { FilterOption } from '../../../common/components/filter/filter-model';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { GrowerProgramService } from '../../../services/seed/growerProgram.service';
import {Subscription } from 'rxjs';
import { ControlType } from '../../../common/components/filter/filter-enum';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { FilterComponent } from '../../../common/components/filter/filter.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-seed-discretionary-dashboard',
  templateUrl: './seed-discretionary-dashboard.component.html',
  styleUrls: ['./seed-discretionary-dashboard.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('detailExpandNew', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SeedDiscretionaryDashboardComponent implements OnInit, OnDestroy {
  @ViewChild(FilterComponent) filterComponent: FilterComponent;

  subscription = new Array<Subscription>();
  filter: any = {};
  prevCropYear: any;
  filterOptionsData: Array<FilterOption>;
  headerYear: any;
  cropYearList: any[] = [];
  headerCompany: any;
  gridData: any[] = []
  buDisplayName: any;

  
  constructor(private growerProgramService: GrowerProgramService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.getLocalStorage();
    this.setDefaultFilter();
    this.setCropYearFilter(this.headerYear);
    this.setFilterAndGridColumn(false,this.headerYear);
    this.getDashboardData(true,false);

  }

  getLocalStorage() {
    if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
      this.headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
    }
    if (this.headerCompany) {
      const evloveAccess = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (evloveAccess) {
        this.cropYearList = evloveAccess.resultData.find(x => x.userIdCompanyCode == this.headerCompany).gpCropYearList;
        // Default to the latest active GP crop year, not the Evolve seed (header) crop year.
        if (this.cropYearList && this.cropYearList.length > 0) {
          this.headerYear = Math.max(...this.cropYearList.map(x => Number(x.id)));
        } else {
          // No GP crop years available -> no default crop year should be selected.
          this.headerYear = null;
        }
        this.prevCropYear = this.headerYear;
      }
    }
    if (this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel)) {
      let salesGenericLevel = JSON.parse(this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel));
      this.buDisplayName = salesGenericLevel.find(x => x.data == MasterConstants.WF_Impl_SplList_BU_Display).value;
    }
  }

  setCropYearFilter(cropyear:any) {
    this.filter.cropYearList = cropyear;
  }

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      cropYearList: null,
      masterBudgetTypeList: null,
      programNameList: null,
      budgetUserList: null,

    };
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn(setdefaultvalue: boolean,cropYear:any) {
    this.filterOptionsData = [
      { label: 'Crop Year', key: 'cropYearList', isMultiSelect: false, controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', filterValue: setdefaultvalue ? cropYear?.toString() : null, controlData: setdefaultvalue ? this.cropYearList : [] },
      { label: 'Master Program Budget Type', key: 'masterProgramBudgetTypeList', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Program Name', key: 'programNameList', controlType: ControlType.ValuesWithIDDropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Budget User', key: 'budgetUserList', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' }
    ]

  }

  toggle(item: any, id: any) {
    item.isExpanded = !item.isExpanded;
    if (!item.isExpanded && id === 1) {
      item.programMasterLevelVMs.forEach(subItem => subItem.isExpanded = false);
    }
  }

  // Set Drop down values for filter
  setDropDownValues(data: any[]) {

    const uniqueProgram = new Set();
    const uniqueBudgetUser = new Set();
    const masterCategoryList: any[] = [];
    const programList: any[] = [];
    const budgetList: any[] = [];
    data.forEach(category => {
      masterCategoryList.push({
        id: category.masterProgramBudgetTypeID,
        value: category.masterProgramBudgetTypeName
      });
      category.programMasterLevelVMs.forEach(program => {
        programList.push({
          id: program.programMasterId,
          value: program.programName + " (" + program.programMasterId + ")"
        });
        program.sdmLevelVMs.forEach(sdmArray => {
          sdmArray.forEach(bud => {
            budgetList.push({
              id: bud.budgetUser,
              value: bud.budgetUserName
            });
          });
        });
      });
    });

    this.filterOptionsData.find(x => x.key === 'masterProgramBudgetTypeList').controlData = Array.from(new Set(masterCategoryList));
    
    this.filterOptionsData.find(x => x.key === 'programNameList').controlData = programList.filter((o) => {
      const isUnique = !uniqueProgram.has(o.id);
      if (isUnique) {
        uniqueProgram.add(o.id);
      }
      return isUnique;
    }).sort((a, b) => a.value.localeCompare(b.value));

    // Filter the data and add unique account numbers to the set
    this.filterOptionsData.find(x => x.key === 'budgetUserList').controlData = budgetList.filter((o) => {
      const isUnique = !uniqueBudgetUser.has(o.id);
      if (isUnique) {
        uniqueBudgetUser.add(o.id);
      }
      return isUnique;
    }).sort((a, b) => a.value.localeCompare(b.value));
    this.filterOptionsData.find(x => x.key === 'cropYearList').controlData = this.cropYearList;
;

  }

  getDashboardData(isBindFilters: boolean, isCropYearChange: boolean = false) {
    this.loaderService.setLoaderStatus(true);
    const cropyear = this.filter.cropYearList == '' ? null : this.filter.cropYearList;
    if (isCropYearChange) {
      this.toastrService.warning('All filters have been reset due to the change in the crop year. Please reapply your filters to continue.');
      this.filterComponent.clearAllFilterWithoutEmit();
      this.setDefaultFilter();
      this.setCropYearFilter(cropyear);
    }
    this.subscription.push(this.growerProgramService.getGrowerProgramSeedDesDataData(this.filter).subscribe((result: any[]) => {
      this.setGridData(result);

        if (isBindFilters || isCropYearChange) {
          this.filterOptionsData = [];
          let IsSetCropYearfilter = isCropYearChange && cropyear == null ? false : true;
          this.setFilterAndGridColumn(IsSetCropYearfilter, cropyear);
          this.setDropDownValues(result);
        }

      this.loaderService.setLoaderStatus(false);
    }, () => {

      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Search Action
  filterSearchClick(filterValue) {
    this.loaderService.setLoaderStatus(true);
    let isCropYearChange = false;
    if (filterValue.cropYearList != this.prevCropYear) {
      isCropYearChange = true;
    }
    this.filter = filterValue;
    this.prevCropYear = this.filter.cropYearList;
    this.getDashboardData(false, isCropYearChange);
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.loaderService.setLoaderStatus(true);
    let isCropYearChange = false;
    if (event.cropYearList != this.prevCropYear) {
      isCropYearChange = true;
    }
    this.filter = event;
    this.prevCropYear = this.filter.cropYearList;
    this.getDashboardData(false, isCropYearChange);
  }
  setGridData(result: any[]) {
    this.gridData = result;
  }


  export() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(
      this.growerProgramService.getExportSeedDesDataData(this.filter).subscribe(result => {
        this.growerProgramService.base64toFile(result.base64, result.mimeType, result.fileName);
        this.loaderService.setLoaderStatus(false);
      },
        (error) => {
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
  }

   formatNagativeValue(value) {
    if (value < 0) {
      return '(' + String(value).split('-')[1] + ')';
    } else {
      return value;
    }
  }

  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
